import {
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom"; //https://reactrouter.com/docs/en

import AppLayout from "./components/layout/AppLayout";
import Certificates from "./pages/Settings/Certificates";
import Dashboard from "./pages/Settings/Dashboard";
import Exception404Page from "./pages/Exception404Page";
import Landingpage from "./pages/LandingPage";
import MyWorks from "./pages/MyWorksPage";
import Profil from "./pages/Settings/Profil";
import React from "react";
import RegisterWork from "./pages/RegisterWorkPage";
import RenderOnAuthenticated from "./keycloak/RenderOnAuthenticated";
import SearchWorks from "./pages/SearchWorksPage";
import SettingsLayout from "./components/layout/SettingsLayout";
import WorkPage from "./pages/WorkPage";
import WorkDetail from "./components/bundel/WorkDetail";
import { Modal } from "./components/ui";

// Protected page wrapper kept terse for the route table below.
const auth = (element) => <RenderOnAuthenticated>{element}</RenderOnAuthenticated>;

// Work detail shown as an overlay over the page the user came from.
function WorkModal() {
  const { grid } = useParams();
  const navigate = useNavigate();
  return (
    <Modal open onClose={() => navigate(-1)}>
      <WorkDetail grid={grid} />
    </Modal>
  );
}

function App() {
  const location = useLocation();
  // When a card sets `state.background`, render that page underneath and the
  // work as a modal on top; direct links (no background) fall through to the
  // full WorkPage route below.
  const background = location.state && location.state.background;

  return (
    <>
      <Routes location={background || location}>
        <Route element={<AppLayout />}>
          {/* public */}
          <Route path="/" index element={<Landingpage />} />
          <Route path="/works/:grid" element={<WorkPage />} />
          <Route path="/searchworks" element={<SearchWorks />} />

          {/* authenticated */}
          <Route path="/registerwork" element={auth(<RegisterWork />)} />
          <Route path="/myworks" element={auth(<MyWorks />)} />

          {/* settings: auth-gated single-page shell */}
          <Route element={auth(<SettingsLayout />)}>
            <Route path="/profil" element={<Profil />} />
            <Route path="/certificates" element={<Certificates />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Route>

          {/* language moved into /profil; old settings paths redirect there */}
          <Route path="/settings" element={<Navigate to="/profil" replace />} />
          <Route path="/config" element={<Navigate to="/profil" replace />} />

          {/* unknown routes */}
          <Route path="*" element={<Exception404Page />} />
        </Route>
      </Routes>

      {background && (
        <Routes>
          <Route path="/works/:grid" element={<WorkModal />} />
        </Routes>
      )}
    </>
  );
}

export default App;
